<!-- EC Configuration Component Template -->
<!-- Migrated from AngularJS to Angular 12 -->

<div class="modal-header">
  <h3 class="modal-title">{{ modalTitle }}</h3>
  <div class="header-actions">
    <i class="fa" 
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" 
       style="margin-right: 10px; cursor: pointer;" 
       (click)="toggleMinimize()"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<div class="modal-body" [hidden]="minimise">
  <div class="panel panel-default">
    <div class="panel-heading">
      <h4><b>EC Configuration Details:</b></h4>
    </div>
    <div class="panel-body">
      <form [formGroup]="configurationForm" (ngSubmit)="isUpdateMode() ? update() : save()">
        
        <!-- First Row: Configuration Item, Configuration Value -->
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="configItem"><b>Configuration Item<sup>*</sup>:</b></label>
              <input type="text" 
                     class="form-control" 
                     id="configItem" 
                     formControlName="CONFIG_ITEM"
                     (input)="onConfigItemChange()"
                     [readonly]="isUpdateMode()"
                     placeholder="Enter Configuration Item">
              @if (configurationForm.get('CONFIG_ITEM')?.invalid && configurationForm.get('CONFIG_ITEM')?.touched) {
<small class="text-danger" 
                    >
                Please provide Configuration Item
              </small>
}
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="configValue"><b>Configuration Value:</b></label>
              <input type="text" 
                     class="form-control" 
                     id="configValue" 
                     formControlName="CONFIG_VALUE"
                     placeholder="Enter Configuration Value">
            </div>
          </div>
        </div>

        <!-- Second Row: From Year, To Year -->
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="fromYear"><b>From Tax Year<sup>*</sup>:</b></label>
              <div class="input-group">
                <input type="text" 
                       class="form-control" 
                       id="fromYear" 
                       formControlName="FROM_YEAR"
                       [value]="fromYear || ''"
                       readonly
                       placeholder="YYYY">
                <span class="input-group-addon" 
                      (click)="openFromYearPicker()"
                      style="cursor: pointer;">
                  <i class="fa fa-calendar"></i>
                </span>
              </div>
              
              <!-- From Year Picker Popup -->
              <gtw-year-picker-popup
                [selectedYear]="fromYear"
                [showPopup]="showFromYearPicker"
                [minYear]="1900"
                [maxYear]="9999"
                [triggerElementId]="'fromYear'"
                (yearSelected)="onFromYearSelected($event)"
                (popupClosed)="closeFromYearPicker()">
              </gtw-year-picker-popup>
              
              @if (configurationForm.get('FROM_YEAR')?.invalid && configurationForm.get('FROM_YEAR')?.touched) {
<small class="text-danger" 
                    >
                Please provide From Tax Year
              </small>
}
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="toYear"><b>To Tax Year<sup>*</sup>:</b></label>
              <div class="input-group">
                <input type="text" 
                       class="form-control" 
                       id="toYear" 
                       formControlName="TO_YEAR"
                       [value]="toYear || ''"
                       readonly
                       placeholder="YYYY">
                <span class="input-group-addon" 
                      (click)="openToYearPicker()"
                      style="cursor: pointer;">
                  <i class="fa fa-calendar"></i>
                </span>
              </div>
              
              <!-- To Year Picker Popup -->
              <gtw-year-picker-popup
                [selectedYear]="toYear"
                [showPopup]="showToYearPicker"
                [minYear]="1900"
                [maxYear]="9999"
                [triggerElementId]="'toYear'"
                (yearSelected)="onToYearSelected($event)"
                (popupClosed)="closeToYearPicker()">
              </gtw-year-picker-popup>
              
              @if (configurationForm.get('TO_YEAR')?.invalid && configurationForm.get('TO_YEAR')?.touched) {
<small class="text-danger" 
                    >
                Please provide To Tax Year
              </small>
}
            </div>
          </div>
        </div>

      </form>
    </div>
  </div>
</div>

<!-- Footer with standardized buttons -->
<div class="modal-footer">
  <button
    class="save-button"
    type="button"
    [disabled]="crudLoading"
    (click)="isUpdateMode() ? update() : save()"
  >
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}
    @if (!isUpdateMode()) {
<span>Create</span>
}
    @if (isUpdateMode()) {
<span>Update</span>
}
  </button>

  <button class="reset-button" type="button" (click)="reset()">Reset</button>

  <button class="cancel-button" type="button" (click)="cancel()">Cancel</button>
</div>

